import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ServerWelcomeChannelInfo {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export type GetServerWelcomeChannelInfoResult = IResult & ServerWelcomeChannelInfo;

export class GetServerWelcomeChannelInfoRequest extends Request<{}, GetServerWelcomeChannelInfoResult> {
  constructor() {
    super('getServerWelcomeChannelInfo', {});
  }
}
